<template>
  <div class="tw:flex tw:items-baseline tw:gap-2">
    <h2 class="mb-0">{{ metric.value.formatted }}</h2>
    <DeltaBadge v-if="metric.delta" :delta="metric.delta" size="lg" />
  </div>
</template>

<script setup lang="ts">
import DeltaBadge from './DeltaBadge.vue';
import type { ValueMetricData } from './metrics';

defineProps<{
  metric: ValueMetricData
}>();
</script>
